import { CrewMember, Scalars } from '@bechtel/types';
import { t } from '@lingui/macro';

export type WeldCrewStats = {
  numWelders: Scalars['Int'];
  numFitupInspection: Scalars['Int'];
  numReadyToWeld: Scalars['Int'];
  numBlocks: Scalars['Int'];
  numVTSentBack: Scalars['Int'];
  numClaimed: Scalars['Int'];
  numVTApproved: Scalars['Int'];
  numPriorityCount: Scalars['Int'];
  numRodRequests: Scalars['Int'];
  numCrews?: Scalars['Int'];
};
export type WeldStatsByPersona = {
  crewMember: CrewMember;
  weldStats: WeldCrewStats;
};

export enum EditWeldTabType {
  VIEW = 'VIEW',
  WELD_DETAILS = 'WELD_DETAILS',
  ASSOCIATED_WELDS = 'ASSOCIATED_WELDS',
}

export interface EditWeldTab {
  label: string;
  value: EditWeldTabType;
}

export const edltWeldTabList: EditWeldTab[] = [
  { label: t`View`, value: EditWeldTabType.VIEW },
  { label: t`Details`, value: EditWeldTabType.WELD_DETAILS },
  { label: t`Associated Welds`, value: EditWeldTabType.ASSOCIATED_WELDS },
];
